import React from "react";
import { useEffect, useState } from "react";
import Asignaturas from "../components/Asignaturas";
import BtnInicioMatricula from "../components/BtnInicioMatricula";
import Card from "../components/Card";
import ProcesoMatricula from "../components/ProcesoMatricula";
import RequisitoMatricula from "../components/RequisitoMatricula";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import DocumentosMatricula from "../components/DocumentosMatricula/DocumentosMatricula";

import {
  apiRequisitosYDocumentos,
  apiFranjaAlumnoPeriodo
} from "../config/constantes";
import BtnDesmatricular from "../components/BtnDesmatricular";
import PerfMetricsButton from "../components/PerfMetricsButton";
import {
  medirBackend,
  medirFrontendRender,
  marcarInicioVista,
  medirCargaTotalVista,
} from "../utils/performance/perfTracker";


const Inicio = () => {
  let {
    obtenerDatosEstudiante,
    listadoFranjas,
    setListadoFranjas,
    setListadoInforMatriDocumento,
    setlistadoRequisitosMatricula,
    setMostrarAsignaturas,
    setMostrarListadoFranjas,
    setFranjaSeleccionadaAsignaturas,
    setAlertaMensaje,
    setDisableListadoFranjas,
    setMultifranjas, setMostrarAlerta,
    matriculaAutomatica, setMatriculaAutomatica
  } = useMatricula();
  let {
    pasoProcesoM,
    setPasoProcesoM,
    setPasoSegundaVistaProcesoM,
    pasoSegundaVistaProcesoM,
    setLoading,
  } = useProcesoMatricula();

  const { cinstitucion, cprograma, cperiodo, cpersona, calumno, franja, flag_mat_aut, cprograma2, gcondicion } =
    obtenerDatosEstudiante || {};

  const [mostrarRequisitosAlerta, setMostrarRequisitosAlerta] = useState(false);

  useEffect(() => {
    marcarInicioVista("Inicio");
  }, []);

  useEffect(() => {
    let { pasomatricula, pasopago } = obtenerDatosEstudiante || {};
    setPasoProcesoM(pasomatricula);
    let pasPago = pasopago == 1 ? false : true;
    setPasoSegundaVistaProcesoM(pasPago);

    if (Object.keys(obtenerDatosEstudiante).length > 0) {
      getData()
      ValidarMatriculaAutomatica()
    }
  }, [obtenerDatosEstudiante]);


  const prometeValidarApi = (api, config) => {
    return new Promise((resolver, rechazar) => {
      fetch(api, config).then((data) => {
        if (data.status == 200) {
          resolver(data);
        } else {
          rechazar(new Error(data));
        }
      });
    });
  };

  const ValidarFranja = () => {
    //valida que la franja actual esté en el catalogo
    let franjaFilter = listadoFranjas.filter(e => franja == e.sfranja)


    let franjaSeleccionadaFilter = listadoFranjas.filter(e => e.bfranja == true)
    let _franja = franjaSeleccionadaFilter[0]?.sfranja;

    if (franjaFilter?.length == 0 && franja != '') {
      setMultifranjas(false)
      setFranjaSeleccionadaAsignaturas('')
    } else {
      if (listadoFranjas.length > 0) {
        setMultifranjas(true)
        setDisableListadoFranjas(false)

        if (_franja != '' && _franja != null) {
          setFranjaSeleccionadaAsignaturas(_franja)
          setMostrarListadoFranjas(true)
          setMostrarAsignaturas(true)
          setMostrarAlerta(false)
        } else {
          setFranjaSeleccionadaAsignaturas('')
          setMostrarAsignaturas(false)
          setMostrarAlerta(true)
          setAlertaMensaje('Seleccione una franja para visualizar la oferta disponible.')
        }
      } else {
        setMultifranjas(false)
      }
    }
  }

  const ValidarMatriculaAutomatica = () => {
    if (flag_mat_aut == 1) {
      setMatriculaAutomatica(true)
    } else {
      setMatriculaAutomatica(false)
    }
  }

  const getData = async () => {
    let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

    let listado_franjas = async () => {
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ` + tokenGlos.access_token,
        },
        body: JSON.stringify({
          p_cinstitucion: Number(cinstitucion),
          p_cprograma: Number(cprograma),
          p_cperiodo: Number(cperiodo),
          p_calumno: Number(calumno),
          p_ctipo: 1
        }),
      };
      try {
        setLoading(true);
        const listaFranjas = await medirBackend(
          "inicio_franjas",
          "Franjas del alumno (listaFranjaAlumnoPeriodo)",
          "Inicio",
          () => prometeValidarApi(`${apiFranjaAlumnoPeriodo}`, config)
        );

        const listaFranjasJson = await listaFranjas.json();
        const { Data } = listaFranjasJson;
        const inicioRender = performance.now();
        setListadoFranjas(Data);
        medirFrontendRender("inicio_franjas_render", "Franjas del alumno - render", "Inicio", inicioRender);
        return Data;
      } catch (error) {
        setMultifranjas(false)
        setLoading(false);
        throw error;
      } finally {
        setLoading(false);
      }
    };

    let listado_requisitosYDocumentos = async () => {
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ` + tokenGlos.access_token,
        },
        body: JSON.stringify({
          p_cinstitucion: cinstitucion,
          p_cprograma: cprograma,
          p_cperiodo: cperiodo,
          p_cpersona: cpersona,
        }),
      };
      try {
        setLoading(true);

        const listaRequisitosYDocumentos = await medirBackend(
          "inicio_requisitos_documentos",
          "Requisitos y documentos (requisitosYDocumentos)",
          "Inicio",
          () => prometeValidarApi(`${apiRequisitosYDocumentos}`, config)
        );

        const listaRequisitosYDocumentosJson = await listaRequisitosYDocumentos.json();
        const { Data } = listaRequisitosYDocumentosJson;
        const inicioRender = performance.now();
        setlistadoRequisitosMatricula(Data?.Requisitos);
        setListadoInforMatriDocumento(Data?.Documentos);
        medirFrontendRender("inicio_requisitos_documentos_render", "Requisitos y documentos - render", "Inicio", inicioRender);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (cinstitucion) {
      await listado_requisitosYDocumentos();
      await listado_franjas()
      medirCargaTotalVista("Inicio", "Vista Inicio - Carga total (datos + render)");
    }
  }

  useEffect(() => {
    if (Object.keys(obtenerDatosEstudiante).length > 0) {
      ValidarFranja()
    }
  }, [listadoFranjas])

  useEffect(() => {
    setPasoProcesoM(pasoProcesoM);
    setPasoSegundaVistaProcesoM(pasoSegundaVistaProcesoM);
  }, [pasoProcesoM, pasoSegundaVistaProcesoM]);

  const mostrarBoton = Number(cprograma2) === 4 && Number(gcondicion) === 5;

  return (
    <>
      <div className="col-12 mb-4 two">
        <ProcesoMatricula />
      </div>
      <div className="col-sm-12 col-md-12 col-lg-4 one">
        <Card />
        {
          matriculaAutomatica &&
          <div className="alert alert-warning mt-4" role="alert">
            <p className="mb-0" style={{ lineHeight: "1.2" }}>
              <svg
                style={{ width: 24, height: 24, marginRight: 5 }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                />

              </svg>
              No puedes realizar la matrícula manual, ya que tienes activa la opción de matrícula automática.
            </p>
          </div>
        }
        {
          mostrarRequisitosAlerta &&
          <div className="alert alert-danger mt-3 d-block d-md-none" role="alert">
            <p className="mb-0" style={{ lineHeight: "1.2" }}>
              <svg
                style={{ width: 24, height: 24, marginRight: 5 }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                />

              </svg>
              Tiene requisitos por cumplir. Por favor, revise los requisitos pendientes.
            </p>
          </div>
        }

        <BtnInicioMatricula mostrarRequisitosAlerta={mostrarRequisitosAlerta}
          setMostrarRequisitosAlerta={setMostrarRequisitosAlerta} />
        {"gencuesta" in (obtenerDatosEstudiante || {}) ? <DocumentosMatricula /> : <></>}

        {
          mostrarBoton &&
          <BtnDesmatricular
            mostrarRequisitosAlerta={mostrarRequisitosAlerta}
            setMostrarRequisitosAlerta={setMostrarRequisitosAlerta} />

        }
      </div>
      <div className="col-md-12 col-lg-8 col-sm-12 three">
        <RequisitoMatricula />
        <Asignaturas />
      </div>

      <PerfMetricsButton vista="Inicio" />
    </>
  );
};

export default Inicio;
